import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { IFlightGroup } from './flight-group';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { environment } from '../../environments/environment';
import { CustomLogger } from '../shared/custom-logger';


@Injectable()
export class FlightGroupService {
  private _flightGroupUrl = environment.flightGroupUrl;

  constructor(
    private _http: HttpClient,
    private logger: CustomLogger
  ) {
  }

  getFlightGroups(params: any, order = ''): Observable<HttpResponse<IFlightGroup[]>> {
    const urlSuf = order;
    return this._http
      .get<IFlightGroup[]>(this._flightGroupUrl + urlSuf, {
        params: params,
        observe: 'response'
      })
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  getFlightGroup(id: number): Observable<IFlightGroup> {
    if (id === 0) {
      return Observable.of(this.initializeFlightGroup());
    }
    const url = `${this._flightGroupUrl}/${id}`;
    return this._http.get<IFlightGroup>(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  initializeFlightGroup(): IFlightGroup {
    return {
      id: 0,
      flightNumber: null,
      departure: {
        id: null,
        name: null
      },
      destination: {
        id: null,
        name: null
      },
      price: null,
      flightDuration: null,
      flightDescriptionEn: null,
      flightDescriptionGe: null
    };
  }

  saveFlightGroup(flightGroup: any): Observable<IFlightGroup> {
    if (flightGroup.id === 0) {
      return this.createFlightGroup(flightGroup);
    }
    return this.updateFlightGroup(flightGroup);
  }

  createFlightGroup(flightGroup: any): Observable<IFlightGroup> {
    flightGroup.id = undefined;

    return this._http.post<IFlightGroup>(this._flightGroupUrl, flightGroup)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  updateFlightGroup(flightGroup: any): Observable<IFlightGroup> {
    const url = `${this._flightGroupUrl}/${flightGroup.id}`;
    return this._http.put<IFlightGroup>(url, flightGroup)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  deleteFlightGroup(id): Observable<any> {
    const url = `${this._flightGroupUrl}/${id}`;
    return this._http.delete(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/flight_group/flight-group.service.ts